<div class="lista-vertical">

  @if (comodos.length > 0) {
    <p-accordion [multiple]="true">
      @for (comodo of comodos; track comodo; let ci = $index) {
        <p-accordion-panel [value]="ci">
          <p-accordion-header>
            <div class="comodo-cabecalho">
              <input pInputText class="comodo-titulo" [id]="'comodoNome' + ci" [(ngModel)]="comodo.nome"
                placeholder="Nome do cômodo"
                (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                <button mat-icon-button matTooltip="Duplicar cômodo"
                  (mousedown)="$event.stopPropagation()" (click)="duplicarComodo(comodo); $event.stopPropagation()">
                  <i class="pi pi-copy"></i>
                </button>
                <button mat-icon-button matTooltip="Remover cômodo"
                  (mousedown)="$event.stopPropagation()" (click)="confirmarRemocao(comodo); $event.stopPropagation()">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </p-accordion-header>
            <p-accordion-content>
              <h4 class="itens-titulo accent-color">Itens de vistoria deste cômodo</h4>
              @for (vinculo of comodo.itens; track vinculo; let vi = $index) {
                <div class="linha-item">
                  <div class="linha-item-corpo">
                    <span class="vinculo-nome">{{ vinculo.item.nome }}</span>
                  </div>
                  <div class="linha-item-acoes">
                    <button mat-icon-button matTooltip="Subir" [disabled]="vi === 0" (click)="moverItem(comodo, vinculo, -1)">
                      <i class="pi pi-chevron-up"></i>
                    </button>
                    <button mat-icon-button matTooltip="Descer" [disabled]="vi === comodo.itens.length - 1" (click)="moverItem(comodo, vinculo, 1)">
                      <i class="pi pi-chevron-down"></i>
                    </button>
                    <button mat-icon-button matTooltip="Remover" (click)="removerItem(comodo, vinculo)">
                      <i class="pi pi-trash"></i>
                    </button>
                  </div>
                </div>
              }
              @if (itensDisponiveis(comodo).length > 0) {
                <app-generic-autocomplete
                  class="adicionar-item-campo"
                  [items]="itensDisponiveis(comodo)"
                  displayField="nome"
                  label="Adicionar item de vistoria"
                  [inputId]="'itemParaAdicionar' + ci"
                  [ngModel]="itemParaAdicionar"
                  (selectionChange)="adicionarItem(comodo, $event)">
                </app-generic-autocomplete>
              }
            </p-accordion-content>
          </p-accordion-panel>
        }
      </p-accordion>
    }

    <button mat-stroked-button class="btn-adicionar" (click)="adicionar()">
      <i class="pi pi-plus"></i> Adicionar cômodo
    </button>

  </div>
